module.exports = __webpack_public_path__ + "static/media/balcony.fa16607e.svg";